/**
 * Report Builder - Place FAQ JavaScript
 *
 * Manages FAQ placement on the report canvas
 */

(function () {
  "use strict";

  // Store placed FAQs
  let placedFaqs = [];
  let faqCounter = 0;
  let isAddingFaqPlaceholder = false;

  /**
   * Initialize the place FAQ functionality
   */
  function initPlaceFaq() {
    // This will be called from the toolbar button click
  }

  /**
   * Add FAQ placeholder to canvas with inline form
   */
  function addFaqPlaceholder() {
    // Prevent duplicate calls
    if (isAddingFaqPlaceholder) {
      return;
    }
    
    isAddingFaqPlaceholder = true;
    
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (!canvasCharts) {
      isAddingFaqPlaceholder = false;
      return;
    }

    // Hide empty message
    if (window.ReportBuilderUtils?.toggleEmptyMessage) {
      window.ReportBuilderUtils.toggleEmptyMessage(false);
    }

    // Create placeholder container
    const placeholderContainer = document.createElement("div");
    placeholderContainer.className = "canvas-faq-placeholder";
    placeholderContainer.id = `faq_placeholder_${Date.now()}`;
    
    // Clone the inline form template
    const inlineFormTemplate = document.querySelector(".report-builder-place-faq-inline");
    if (!inlineFormTemplate) {
      console.error("Inline FAQ form template not found");
      isAddingFaqPlaceholder = false;
      return;
    }

    const inlineForm = inlineFormTemplate.cloneNode(true);
    inlineForm.style.display = "block";
    inlineForm.id = `inline_faq_form_${Date.now()}`;

    // Update IDs to be unique
    const selectFaq = inlineForm.querySelector("#inlineSelectFaq");
    const addFaqBtn = inlineForm.querySelector("#inlineAddFaqBtn");
    
    if (selectFaq) {
      selectFaq.id = `inlineSelectFaq_${Date.now()}`;
    }
    if (addFaqBtn) {
      addFaqBtn.id = `inlineAddFaqBtn_${Date.now()}`;
    }

    placeholderContainer.appendChild(inlineForm);
    canvasCharts.appendChild(placeholderContainer);

    // Initialize form handlers for this instance
    initInlineFaqFormInstance(inlineForm, placeholderContainer);

    // Scroll to the new placeholder
    placeholderContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
    
    // Reset flag after a short delay
    setTimeout(function() {
      isAddingFaqPlaceholder = false;
    }, 100);
  }

  /**
   * Initialize inline FAQ form instance
   */
  function initInlineFaqFormInstance(formElement, placeholderContainer) {
    const selectFaq = formElement.querySelector("select[id^='inlineSelectFaq']");
    const addFaqBtn = formElement.querySelector("button[id^='inlineAddFaqBtn']");
    const cancelButtons = formElement.querySelectorAll(".btn-cancel-faq-config");

    if (!selectFaq || !addFaqBtn) {
      return;
    }

    // Handle FAQ selection
    selectFaq.addEventListener("change", function () {
      const hasFaq = selectFaq.value !== "";
      addFaqBtn.disabled = !hasFaq;
    });

    // Handle add FAQ button
    addFaqBtn.addEventListener("click", function () {
      addFaqFromInlineFormInstance(formElement, placeholderContainer);
    });

    // Handle cancel buttons
    cancelButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        placeholderContainer.remove();
        
        // Show empty message if no items left
        const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
        if (canvasCharts && canvasCharts.children.length === 0) {
          if (window.ReportBuilderUtils?.toggleEmptyMessage) {
            window.ReportBuilderUtils.toggleEmptyMessage(true);
          }
        }
      });
    });
  }

  /**
   * Add FAQ from inline form instance
   */
  function addFaqFromInlineFormInstance(formElement, placeholderContainer) {
    const selectFaq = formElement.querySelector("select[id^='inlineSelectFaq']");

    if (!selectFaq || !selectFaq.value) {
      return;
    }

    const selectedOption = selectFaq.options[selectFaq.selectedIndex];
    const faqId = parseInt(selectFaq.value);
    const faqTitle = selectedOption.getAttribute("data-faq-title") || selectedOption.textContent;
    const faqContent = selectedOption.getAttribute("data-faq-content") || "";

    // Create unique FAQ ID
    const faqItemId = `report_faq_${++faqCounter}_${Date.now()}`;

    // Create FAQ configuration
    const faqConfig = {
      id: faqItemId,
      faqPostId: faqId,
      title: faqTitle,
      content: faqContent,
      customTitle: null, // Will default to FAQ title if null
    };

    // Add to placed FAQs
    placedFaqs.push(faqConfig);

    // Replace placeholder with FAQ
    renderFaqInCanvas(faqConfig, placeholderContainer);
  }

  /**
   * Render FAQ in canvas
   */
  function renderFaqInCanvas(faqConfig, placeholder = null) {
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (!canvasCharts) {
      return;
    }

    // Create FAQ container
    const faqContainer = document.createElement("div");
    faqContainer.className = "canvas-faq-item";
    faqContainer.id = `faq_container_${faqConfig.id}`;
    faqContainer.setAttribute("data-faq-id", faqConfig.id);

    // Create FAQ header with controls
    const faqHeader = document.createElement("div");
    faqHeader.className = "faq-item-header";
    const displayTitle = faqConfig.customTitle || faqConfig.title;
    
    if (window.ReportBuilderUtils?.generateItemHeaderHtml) {
      faqHeader.innerHTML = window.ReportBuilderUtils.generateItemHeaderHtml({
        itemId: faqConfig.id,
        displayTitle: displayTitle,
        idAttribute: "data-faq-id",
        itemType: "faq",
        removeButtonClass: "btn-remove-faq",
        removeButtonTitle: "Remove FAQ",
      });
    } else {
      // Fallback if utils not available
      faqHeader.innerHTML = `<div class="faq-item-title"><h4>${displayTitle}</h4></div>`;
    }

    // Create FAQ content area
    const faqContent = document.createElement("div");
    faqContent.className = "faq-item-content";
    faqContent.innerHTML = `
            <div class="faq-answer"> 
                <div class="faq-answer-content">${faqConfig.content}</div>
            </div>
        `;

    // Assemble FAQ container
    faqContainer.appendChild(faqHeader);
    faqContainer.appendChild(faqContent);

    // Replace placeholder or add to canvas
    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.replaceChild(faqContainer, placeholder);
    } else {
      canvasCharts.appendChild(faqContainer);
    }

    // Setup move buttons
    if (window.ReportBuilderUtils?.setupMoveButtons) {
      window.ReportBuilderUtils.setupMoveButtons(
        faqContainer,
        faqConfig.id,
        "data-faq-id",
        function() {
          updateFaqArrayOrder(faqConfig.id);
        }
      );
    }

    // Setup edit title button
    if (window.ReportBuilderUtils?.setupEditTitleButton) {
      window.ReportBuilderUtils.setupEditTitleButton(
        faqContainer,
        faqConfig.id,
        "faq",
        function(newTitle) {
          faqConfig.customTitle = newTitle;
        }
      );
    }

    // Setup remove button
    const removeBtn = faqContainer.querySelector(".btn-remove-faq");
    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        if (window.ReportBuilderUtils?.showConfirmationModal) {
          window.ReportBuilderUtils.showConfirmationModal({
            title: "Remove FAQ",
            message: "Are you sure you want to remove this FAQ? This action cannot be undone.",
            confirmText: "Remove",
            cancelText: "Cancel",
            onConfirm: function() {
              removeFaq(faqConfig.id);
            }
          });
        } else {
          // Fallback if modal not available
          if (confirm("Are you sure you want to remove this FAQ?")) {
            removeFaq(faqConfig.id);
          }
        }
      });
    }
  }

  /**
   * Update FAQ array order to match DOM order
   */
  function updateFaqArrayOrder(faqId) {
    if (window.ReportBuilderUtils?.updateArrayOrder) {
      window.ReportBuilderUtils.updateArrayOrder(
        placedFaqs,
        faqId,
        "faq_container_",
        "data-faq-id"
      );
    }
  }

  /**
   * Remove FAQ from canvas
   */
  function removeFaq(faqId) {
    // Remove from placed FAQs array
    placedFaqs = placedFaqs.filter((f) => f.id !== faqId);

    // Remove from DOM
    const faqContainer = document.getElementById(`faq_container_${faqId}`);
    if (faqContainer) {
      faqContainer.remove();
    }

    // Show empty message if no items left
    const canvasCharts = window.ReportBuilderUtils?.getCanvasContainer();
    if (canvasCharts && canvasCharts.children.length === 0) {
      if (window.ReportBuilderUtils?.toggleEmptyMessage) {
        window.ReportBuilderUtils.toggleEmptyMessage(true);
      }
    }
  }

  // Export functions for external use
  window.ReportBuilderFaq = {
    addFaqPlaceholder: addFaqPlaceholder,
    removeFaq: removeFaq,
  };

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPlaceFaq);
  } else {
    initPlaceFaq();
  }
})();

